import React from "react";

import styles from './Notification.module.css';
import { notificationActions } from '../../store/notification/notification-slice';
import { useDispatch } from 'react-redux';
import { xIcon } from '@progress/kendo-svg-icons';
import { SvgIcon } from "@progress/kendo-react-common";

const Notification = (props) => {
  const dispatch = useDispatch();
  let secondaryClass = '';

  if (props.status === 'error') {
    secondaryClass = styles.error;
  } else if (props.status === 'success') {
    secondaryClass = styles.success;
  }

  const onClickHandler = () => {
    dispatch(notificationActions.clearNotification());
  }

  return (
    <section className={`${styles.notification} ${secondaryClass}`} onClick={onClickHandler}>
        <p className={styles.text} >{props.message}</p>
        <span className={styles.icon}>
          <SvgIcon icon={xIcon} style={{fontSize: "18px", width: "18px", height: "18px"}}/>
        </span>
    </section>
  );
}

export default Notification;